import React from "react";
import { Divider, Button } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Ozone from "./Images/Ozone.webp";
import TurtleBags from "./Images/Turtle-Bags.webp";
import HawksbillGroup from "./Images/Hawksbill-Group.png";
// import NationwidePaymentSystems from "./Images/Nationwide-Payment-Systems.webp";
import ForceEScubaCenters from "./Images/Force-E-Scuba-Centers.png";
import Link from '@mui/material/Link';
import CustomPaginationActionsTable from "./WeSupport";

const theme = createTheme({
  palette: {
    primary: {
      main: "#bbc7d6", // custom primary color
    },
    secondary: {
      main: "#F27920", // custom secondary color
    },
  },
});

export default function Sponsors() {
  return (

    <div>

      <div className='p-10 container mx-auto bg-white my-20'>
        <h1 className="text-2xl font-bold mb-4">Sponsors</h1>
        <Divider style={{ backgroundColor: '#009293' }} />

        <div className="lg:flex gap-4 pt-4">
          <div className="lg:w-8/12">
            <p className="pb-2">Many thanks to our generous sponsors.</p>
            <p>You can become one too!</p>
          </div>
          <div className="lg:w-4/12">

            <ThemeProvider theme={theme}>
              <Button variant="contained" size="large" fullWidth color="secondary" className="h-full w-full">
                <Link style={{
                  color: "#FFFFFF",
                  fontWeight: "bold",
                  textDecoration: "none",
                }}>Become a Corporate Partner Today!</Link>
              </Button>
            </ThemeProvider>
          </div>
        </div>

        <div className="lg:flex gap-5 justify-center mt-20">

          <div className="mb-10 lg:w-4/12">
            <ThemeProvider theme={theme}>
              <Button variant="" fullWidth color="primary" className="h-full w-full">
                <a
                  href="https://www.ozonesocks.com/"
                  target="_blank"
                  rel="noreferrer"
                  color={"inherit"}
                  style={{ textDecoration: "none", fontWeight: "bold" }}
                >
                  <img src={Ozone} alt="" className="mx-auto " />
                  <span className="text-[#2E1500]">Ozone Design, Inc.</span>
                </a>
              </Button>
            </ThemeProvider>
          </div>
          <div className="mb-10 lg:w-4/12">
            <ThemeProvider theme={theme}>
              <Button variant="" fullWidth color="primary" className="h-full w-full">
                <a
                  href="https://turtlebagsinc.com/"
                  target="_blank"
                  rel="noreferrer"
                  color={"inherit"}
                  style={{ textDecoration: "none", fontWeight: "bold" }}
                >
                  <img src={TurtleBags} alt="" className="mx-auto" />
                  <span className="text-[#2E1500]">Turtle Bags Inc.</span>
                </a>
              </Button>
            </ThemeProvider>
          </div>
          <div className="mb-10 lg:w-4/12">
            <ThemeProvider theme={theme}>
              <Button variant="" fullWidth color="primary" className="h-full w-full">
                <a
                  href="https://hawksbillgroup.com/"
                  target="_blank"
                  rel="noreferrer"
                  color={"inherit"}
                  style={{ textDecoration: "none", fontWeight: "bold" }}
                >
                  <img src={HawksbillGroup} alt="" className="mx-auto" />
                  <span className="text-[#2E1500]">The Hawksbill Group</span>
                </a>
              </Button>
            </ThemeProvider>
          </div>


        </div>
        <div className="lg:flex gap-5 justify-center">
          <div className="mb-10 lg:w-6/12">
            <ThemeProvider theme={theme}>
              <Button variant="" fullWidth color="primary" className="h-full w-full">
                <a
                  href="https://nationwidepaymentsystems.com/"
                  target="_blank"
                  rel="noreferrer"
                  color={"inherit"}
                  style={{ textDecoration: "none", fontWeight: "bold" }}
                >
                  <img src="https://nationwidepaymentsystems.com/wp-content/uploads/2022/01/Nationwide-Payment-Systems_FINAL-01-300x84.png" alt="" className="mx-auto" />
                  <span className="text-[#2E1500]">Nationwide Payment Systems, Inc.</span>
                </a>
              </Button>
            </ThemeProvider>
          </div>
          <div className="mb-10 lg:w-6/12">
            <ThemeProvider theme={theme}>
              <Button variant="" fullWidth color="primary" className="h-full w-full">
                <a
                  href="https://www.force-e.com/"
                  target="_blank"
                  rel="noreferrer"
                  color={"inherit"}
                  style={{ textDecoration: "none", fontWeight: "bold" }}
                >
                  <img src={ForceEScubaCenters} alt="" className="mx-auto" />
                  <span className="text-[#2E1500]">Force-E Dive Centers</span>
                </a>
              </Button>
            </ThemeProvider>
          </div>
        </div>

      </div>
      <div className='p-10 container mx-auto bg-white my-20'>
        <CustomPaginationActionsTable />
      </div>


    </div>
  );
}
